export const routesWithoutReload = [
  'member-account',
  'member-notes',
  'member-hr',
  'member-security',
  'member-company-details',
  'member-license-info',
  'member-compensation',
  'member-documents',
  'member-login',
  'dashboard',
  'sign',
  'sign-list',
  'administration-data-management',
  'availability',
  'user-profile',
  'user-security',
  'user-permissions',
  'user-settings',
  'user-main',
  'settings-dashboard',
  'settings-notifications',
  'settings-opex',
  'user-subscription',
  'user-apps',
  'user-downloads',
  'exports',
  'reports',
  'settings-focus-area',
  'settings-ai-keys',
  'pipelines-dashboard',
  'deals-dashboard',
  'availabilities-dashboard',
  'data-management-lease-ingestion',
  'data-management-lease-ingestion-detail',
  'data-management-availability-ingestion',
  'data-management-availability-ingestion-detail',
  'permissions-settings',
  'comparables-dashboard',
  'spatial-search',
  '404',
  'companies',
  'properties',
  'contacts',
  'occupiers',
  'requirements',
  'availabilities',
  'comparables',
  'projects',
  'pipelines',
  'deals',
  'sets',
  'members',
  'administration-requests',
  'PressReleases',
  'marketing-eblasts',
  'marketing-campaigns',
  'marketing',
  'documents',
  'reset-password',
];
